import axiosServices from '@services/axiosServices';
import actionsProfile from './actions';
import { API_HOST, API } from '@configs/api';
import actionsAlert from '../alert/actions';
import { getUserId } from '@services/authentificationServices';
import { logOut } from '../authentification/actionCreator';

const {
    userDetails,
    userMultiposting,
    editUserDetails,
    uploadProfileImage,
    addFormation,
    deleteFormation,
    editFormation,
    deleteFile,
    deleteFiles,
    addExp,
    deleteExp,
    editExp,
    getLangLevels,
    getEduLevels,
    getEduLevel,
    getPredefLang,
    getFilteredfLangs,
    getJobTypes,
    checkCandidateHadCandidatres,
} = actionsProfile;
const { alert } = actionsAlert;

const getUserDetails = () => {
    const URL = API_HOST + API.profile.candidate + getUserId();
    return async (dispatch) => {
        axiosServices.get(URL).then(
            (res) => {
                dispatch(userDetails({ data: res.data }));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const getMultiposting = () => {
    const URL = API_HOST + API.profile.multiposting + `/${getUserId()}`;
    return async (dispatch) => {
        axiosServices.get(URL).then((res) => {
            dispatch(userMultiposting(res.data.items));
        });
    };
};

const editCandidateDetails = (
    data,
    setShowErrorExistMail,
    setShowErrorOldPassword,
    showEditEmail,
    showEditPassword,
    desactivate,
) => {
    const URL = API_HOST + API.profile.editCandidate + getUserId();
    return async (dispatch) => {
        axiosServices.patch(URL, data).then(
            (res) => {
                dispatch(editUserDetails(res.data));
                dispatch(getUserDetails());
                dispatch(getMultiposting());
                showEditEmail || showEditPassword
                    ? dispatch(
                          alert({
                              msg: 'success_operation',
                              type: 'success',
                              redirectLink: 'title_popup_logout',
                          }),
                      )
                    : dispatch(alert({ msg: 'success_operation', type: 'success' }));
                setTimeout(() => {
                    if (showEditEmail || showEditPassword || desactivate) dispatch(logOut());
                }, 1000);
            },
            (err) => {
                if (err.response && err.response.status && err.response.status === 400) {
                    if (err.response.data.message === 'email already used') {
                        dispatch(alert({ msg: 'email_exist', type: 'error' }));
                        setShowErrorExistMail(true);
                    } else if (err.response.data.message === 'incorrect old password') {
                        dispatch(alert({ msg: 'incorrect_old_password', type: 'error' }));
                        setShowErrorOldPassword(true);
                    } else {
                        dispatch(alert({ msg: 'failed_operation', type: 'error' }));
                    }
                } else {
                    dispatch(alert({ msg: 'failed_operation', type: 'error' }));
                }
            },
        );
    };
};

const changeProfileImage = (formData) => {
    const URL = API_HOST + API.profile.uploadImage + getUserId();
    return async (dispatch) => {
        axiosServices.post(URL, formData).then(
            (res) => {
                dispatch(uploadProfileImage({ data: res.data }));
                dispatch(getUserDetails());
                dispatch(alert({ msg: 'success_upload_image', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'error_upload_image', type: 'error' }));
            },
        );
    };
};

const formationAdded = (formData) => {
    const URL = API_HOST + API.profile.addingFormation;
    return async (dispatch) => {
        axiosServices.post(URL, formData).then(
            (res) => {
                dispatch(addFormation({ data: res.data }));
                dispatch(getUserDetails());
                dispatch(alert({ msg: 'success_operation', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

const formationDeleted = (id) => {
    const URL = API_HOST + API.profile.deletingFormation + id;
    return async (dispatch) => {
        axiosServices.delete(URL).then(
            (res) => {
                dispatch(deleteFormation({ data: res.data }));
                dispatch(getUserDetails());
                dispatch(alert({ msg: 'success_save_add', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

const experienceAdded = (formData) => {
    const URL = API_HOST + API.profile.addingProfessionalExperience;
    return async (dispatch) => {
        axiosServices.post(URL, formData).then(
            (res) => {
                dispatch(addExp({ data: res.data }));
                dispatch(getUserDetails());
                dispatch(alert({ msg: 'success_save_add', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

const experienceDeleted = (id) => {
    const URL = API_HOST + API.profile.deletingProfessionalExperience + id;
    return async (dispatch) => {
        axiosServices.delete(URL).then(
            (res) => {
                dispatch(deleteExp({ data: res.data }));
                dispatch(getUserDetails());
                dispatch(alert({ msg: 'success_operation', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

const fileDeleted = (id) => {
    const URL = API_HOST + API.profile.deletingFile + id;
    return async (dispatch) => {
        axiosServices.delete(URL).then(
            (res) => {
                dispatch(deleteFile({ data: res.data }));
                dispatch(getUserDetails());
                dispatch(alert({ msg: 'success_operation', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

const filesDeleted = (ids) => {
    const URL = API_HOST + API.profile.deletingFiles;
    return async (dispatch) => {
        axiosServices.post(URL, ids).then(
            (res) => {
                dispatch(deleteFiles({ data: res.data }));
                dispatch(getUserDetails());
                dispatch(alert({ msg: 'success_operation', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

const formationedited = (id, formData) => {
    const URL = API_HOST + API.profile.deletingFormation + id + '/edit';
    return async (dispatch) => {
        axiosServices.post(URL, formData).then(
            (res) => {
                dispatch(editFormation({ data: res.data }));
                dispatch(getUserDetails());
                dispatch(alert({ msg: 'success_save_updates', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

const expEdited = (id, formData) => {
    const URL = API_HOST + API.profile.deletingProfessionalExperience + id + '/edit';
    return async (dispatch) => {
        axiosServices.patch(URL, formData).then(
            (res) => {
                dispatch(editExp({ data: res.data }));
                dispatch(getUserDetails());
                dispatch(alert({ msg: 'success_save_updates', type: 'success' }));
            },
            (err) => {
                dispatch(alert({ msg: 'failed_operation', type: 'error' }));
            },
        );
    };
};

const gettingLangLevels = () => {
    const URL = API_HOST + API.profile.langLevels;
    return async (dispatch) => {
        axiosServices.get(URL).then(
            (res) => {
                let tab = [];
                res.data.map((level) => {
                    tab.push({ label: level.name, value: level.name });
                });
                dispatch(getLangLevels(tab));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const gettingEduLevels = () => {
    const URL = API_HOST + API.profile.diplomas;
    return async (dispatch) => {
        axiosServices.get(URL).then(
            (res) => {
                dispatch(getEduLevels(res.data));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const gettingEduLevel = () => {
    const URL = API_HOST + API.profile.educLevel;
    return async (dispatch) => {
        axiosServices.get(URL).then(
            (res) => {
                dispatch(getEduLevel(res.data));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const gettingLangs = () => {
    const URL = API_HOST + API.profile.preDefLang;
    return async (dispatch) => {
        axiosServices.post(URL).then(
            (res) => {
                let tab = [];
                res.data.map((lang) => {
                    tab.push({id:lang.id, label: lang.name, value: lang.id });
                });
                dispatch(getPredefLang(tab));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const gettingFilteredLangs = (data) => {
    const URL = API_HOST + API.profile.FilterLangs;
    return async (dispatch) => {
        axiosServices.post(URL, { needle: data }).then(
            (res) => {
                let tab = [];
                res.data.map((lang) => {
                    tab.push({ label: lang.name, value: lang.id });
                });
                dispatch(getFilteredfLangs(tab));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const gettingJobTypes = (dataLocal) => {
    const URL = API_HOST + API.profile.jobTypes;
    return async (dispatch) => {
        axiosServices.get(URL, { params: dataLocal }).then(
            (res) => {
                dispatch(getJobTypes(res.data));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const getUserDetailsById = (id) => {
    const URL = API_HOST + API.profile.candidate + id;
    return async (dispatch) => {
        axiosServices.get(URL).then(
            (res) => {
                dispatch(userDetails({ data: res.data }));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

const deleteCandidate = () => {
    const URL = API_HOST + API.profile.delete + getUserId();
    return async (dispatch) => {
        axiosServices.delete(URL).then(
            (res) => {
                dispatch(alert({ msg: 'success_save_updates', type: 'success' }));
                dispatch(logOut());
            },
            (err) => {
                if (
                    err.response.data.error &&
                    err.response.data.error.includes(' Contactez le support pour la suppression du votre compte')
                ) {
                    dispatch(alert({ msg: 'echec_delete_account', type: 'warning' }));
                } else {
                    dispatch(alert({ msg: 'failed_operation', type: 'error' }));
                }
            },
        );
    };
};

const checkCandidateHadMissions = () => {
    const URL = API_HOST + API.profile.checkCandidateCandidatures;

    return async (dispatch) => {
        axiosServices.post(URL, { id_candidat: getUserId() }).then(
            (res) => {
                dispatch(checkCandidateHadCandidatres(res.data.result));
            },
            (err) => {
                console.log(err);
            },
        );
    };
};

export {
    getUserDetailsById,
    getUserDetails,
    getMultiposting,
    editCandidateDetails,
    changeProfileImage,
    formationAdded,
    formationDeleted,
    formationedited,
    fileDeleted,
    filesDeleted,
    experienceAdded,
    experienceDeleted,
    expEdited,
    gettingLangLevels,
    gettingEduLevels,
    gettingEduLevel,
    gettingLangs,
    gettingFilteredLangs,
    gettingJobTypes,
    deleteCandidate,
    checkCandidateHadMissions,
};
